// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2NoJo","notes":"Notes_notes___820m"};